import { Routes, Route } from 'react-router-dom'
import Layout from '@/components/Layout'
import Dashboard from '@/pages/Dashboard'
import APIExplorer from '@/pages/APIExplorer'
import APIKeys from '@/pages/APIKeys'
import Analytics from '@/pages/Analytics'
import Documentation from '@/pages/Documentation'
import Settings from '@/pages/Settings'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/explorer" element={<APIExplorer />} />
        <Route path="/api-keys" element={<APIKeys />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/docs" element={<Documentation />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Layout>
  )
}

export default App
